import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserSettingsService } from './components/account/settings/services/user-settings.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Retirolêz';

  constructor(userSettings: UserSettingsService){
    // Theme and sidenav choices are saved in the user profile
    userSettings.start()
  }

  ngOnInit(): void {
    console.error('AppComponent -> ngOnInit')
  }

  ngOnDestroy(): void {
    console.warn('AppComponent -> ngOnDestroy');
  }
}
